/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e){function n(){"loading"!==document.readyState&&(e(),document.removeEventListener("DOMContentLoaded",n))}"undefined"!=typeof window&&"undefined"!=typeof document&&(document.addEventListener("DOMContentLoaded",n),n())}export{e as onDocumentReady};
//# sourceMappingURL=document-ready.js.map
